export default __webpack_public_path__ + "static/media/wot_001.f467f530.JPG";